import { fromJS, OrderedMap, Map, List } from 'immutable';

/**
 * Use of local storage can fail if the user has disabled permission for the browser to use that feature
 */

export const loadCopyState = () => {
  let copyState = Map();

  try {
    if (get('pasteCellsMode'))
      copyState = copyState.set('pasteCellsMode', get('pasteCellsMode'));
    if (get('pastableCells')) {
      const orderedPastableCells = formatPastableCells(get('pastableCells'));
      copyState = copyState.set('pastableCells', orderedPastableCells);
    }
    if (get('cutCells')) {
      const orderedCutCells = formatCutCells(get('cutCells'));
      copyState = copyState.set('cutCells', orderedCutCells);
    }
    if (get('pastableCellParams'))
      copyState = copyState.set(
        'pastableCellParams',
        Map(get('pastableCellParams')),
      );
    if (get('pasteMode'))
      copyState = copyState.set('pasteMode', get('pasteMode'));
    if (get('pastableRows')) {
      const pastableRows = get('pastableRows').map((row) => {
        row.labels = List(row.labels);
        row.item.orderedCells = List(row.item.orderedCells);
        return row;
      });
      copyState = copyState.set('pastableRows', pastableRows);
    }
    if (get('pastableRowIds')) {
      copyState = copyState.set(
        'pastableRowIds',
        formatPastableRowIds(get('pastableRowIds')),
      );
    }
    if (get('rowSelectionMode')) {
      copyState = copyState.set('rowSelectionMode', get('rowSelectionMode'));
    }

    sessionStorage.clear();

    return copyState;
  } catch (e) {
    console.log('Failed to load application state', e);
    sessionStorage.clear();
    return Map();
  }
};

export const persistCopyState = (state) => {
  try {
    if (state.get('pasteCellsMode'))
      set('pasteCellsMode', state.get('pasteCellsMode'));
    if (state.get('pastableCells'))
      set('pastableCells', state.get('pastableCells').toJS());
    if (state.get('cutCells')) set('cutCells', state.get('cutCells').toJS());
    if (state.get('pastableCellParams'))
      set('pastableCellParams', state.get('pastableCellParams').toJS());

    if (state.get('pasteMode')) set('pasteMode', state.get('pasteMode'));
    if (state.get('pastableRows'))
      set('pastableRows', state.get('pastableRows'));
    if (state.get('pastableRowIds'))
      set('pastableRowIds', state.get('pastableRowIds').toJS());
    if (state.get('rowSelectionMode'))
      set('rowSelectionMode', state.get('rowSelectionMode'));
  } catch (e) {
    //log and continue
    console.log('Failed to persist application state', e);
  }
};

function set(id, value) {
  if (typeof value === 'object') value = JSON.stringify(value);
  sessionStorage.setItem(id, value);
}

function get(id) {
  const value = sessionStorage.getItem(id);
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
}

function formatPastableCells(cells) {
  let orderedCells = OrderedMap();
  Object.keys(cells).forEach((key) => {
    let cell = cells[key];
    const { cellSpec, data, originalRowIndex, rowId } = cell;
    const { rteState, format, userId } = data;
    const { type, value } = cellSpec;
    cell.cellSpec = Map({
      type,
    });
    if (value) {
      cell = cell.cellSpec.set('value', value);
    }
    cell.rowId = rowId;
    cell.originalRowIndex = originalRowIndex;
    cell.data = Map({
      rteState: fromJS(rteState),
      format: fromJS(format),
      userId,
    });
    orderedCells = orderedCells.set(key, cell);
  });
  return orderedCells;
}

function formatCutCells(cells) {
  let cutCells = OrderedMap();
  let rows = Object.keys(cells);
  rows.forEach((row) => {
    let rowCells = OrderedMap();
    let colIds = Object.keys(cells[row]);
    colIds.forEach((colId) => {
      let cellData = cells[row][colId];
      const formattedCellData = Map({
        rteState: fromJS(cellData.rteState),
        format: fromJS(cellData.format),
        userId: cellData.userId,
      });
      rowCells = rowCells.set(colId, formattedCellData);
    });
    cutCells = cutCells.set(row, rowCells);
  });

  return cutCells;
}

function formatPastableRowIds(pastableRowIds) {
  let formattedPastableRowIds = List();
  pastableRowIds.forEach((rowData) => {
    formattedPastableRowIds = formattedPastableRowIds.push(Map(rowData));
  });

  return formattedPastableRowIds;
}
